import { connect } from 'react-redux';
import { IFavoriteButtonProps, FavoriteButton } from '../../components/FavoriteButton';
import { getIsFavorite } from '../../selectors/newbuilding';
import { selectMessageButtonAvailable } from '../../selectors/messageButton';
import { getNewbuildingId } from '../../selectors/newbuilding/getNewduildingId';
import { getGALabel } from '../../selectors/newbuilding/getGALabel';
// eslint-disable-next-line import/no-restricted-paths
import { addFavorite, removeFavorite } from '../../../browser/services/favorite';
import { TApplicationState, TDispatch } from '../../types/redux';

type TFavoriteButtonStateProps = Pick<IFavoriteButtonProps, 'isFavorite' | 'newbuildingId' | 'gaLabel' | 'hideText'>;

type TExternalFavoriteButtonProps = {
  isHeader?: boolean;
};

type TCompDispatchProps = Pick<IFavoriteButtonProps, 'actionAddFavorite' | 'actionRemoveFavorite'> &
  TFavoriteButtonStateProps;

interface IFavoriteButtonDispatchProps {
  dispatchAddFavorite(newbuildingId: number, gaLabel: string): void;
  dispatchRemoveFavorite(newbuildingId: number, gaLabel: string): void;
}

export function mapStateToProps(
  state: TApplicationState,
  ownProps: TExternalFavoriteButtonProps,
): TFavoriteButtonStateProps {
  return {
    isFavorite: getIsFavorite(state),
    hideText: Boolean(ownProps.isHeader) && selectMessageButtonAvailable(state),
    newbuildingId: getNewbuildingId(state),
    gaLabel: getGALabel(state),
  };
}

export const mapDispatchToProps = (dispatch: TDispatch): IFavoriteButtonDispatchProps => {
  return {
    dispatchAddFavorite: () => {
      dispatch(addFavorite());
    },
    dispatchRemoveFavorite: () => {
      dispatch(removeFavorite());
    },
  };
};

export function mergeProps(
  stateProps: TFavoriteButtonStateProps,
  dispatchProps: IFavoriteButtonDispatchProps,
): TCompDispatchProps {
  const { newbuildingId, gaLabel } = stateProps;

  return {
    actionAddFavorite: () => dispatchProps.dispatchAddFavorite(newbuildingId, gaLabel),
    actionRemoveFavorite: () => dispatchProps.dispatchRemoveFavorite(newbuildingId, gaLabel),
    ...stateProps,
  };
}

export const FavoriteButtonContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(FavoriteButton);
